import React, { useState, useEffect } from 'react';
import {
  Loader,
  Box,
  Text,
  Spacer,
  Tabs,
  Grid,
  Button,
} from '@flexisaf/flexibull2';
import styled from 'styled-components';
import request from 'utils/request';
import config from 'utils/config';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { SideModalFullScreen } from 'components/styles/applicantModal.style';
import Theme from 'utils/theme';
import { StatusIndicator } from '@flexisaf/flexibull2/build/statusindicator';
import { stepTypeColor } from 'components/WorkflowSteps/utils';
import { processForm } from 'utils/processFormUtil';
import {
  getColumnStructure,
  formatAddress,
} from 'components/applicants/ApplicantModals/SingleApplicant';
import {} from 'components/applicants/ApplicantModals/SingleApplicant';
import { EMPTY_VALUE, FALL_BACK_TZ } from 'utils/constants';
const moment = require('moment-timezone');

const VerifyCandidateInfo = () => {
  const { params } = useRouteMatch();
  const history = useHistory();

  const [applicantInfo, setApplicantInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formItemData, setFormItemData] = useState({});
  const [formItem, setFormItem] = useState([]);

  useEffect(() => {
    const getCandidateInfo = async () => {
      setLoading(true);
      const url = `${config.API_BASE_URL}/candidate-info/${params.id}`;
      const response = await request({ method: 'get', url });
      if (response.success) {
        const {
          raw: { candidate, formData, formSchema },
        } = response;
        setApplicantInfo({ candidate, formData, formSchema });
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    getCandidateInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (applicantInfo?.formData) {
      const newFormValues = { ...applicantInfo?.formData.data };
      (applicantInfo?.formData?.attachments || []).forEach((a) => {
        newFormValues[a.name.split('-').reverse()[0]] = [
          { ...a, type: a.mimetype, saved: true },
        ];
      });
      setFormItemData({ ...newFormValues });
    }
  }, [applicantInfo]);

  useEffect(() => {
    if (applicantInfo?.formSchema) {
      const processed = processForm(
        applicantInfo?.formSchema,
        applicantInfo?.formData?.data?.duplicateFields || {}
      );
      setFormItem(processed);
    }
  }, [applicantInfo]);

  const login = () => {
    localStorage.setItem('app_redirect', applicantInfo?.candidate?.applicationId);
    history.push(`/${params.orgName}`)
  };

  return (
    <Wrapper>
      {loading ? (
        <Box
          margin="50vh auto"
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Loader />
        </Box>
      ) : (
        <>
          <SideModalFullScreen fullScreen>
            <div className="side-container">
              <>
                <div className="applicant-info">
                  <div className="applicant-info-details">
                    <Box>
                      <Text bold block size="20px">
                        {applicantInfo?.candidate?.firstName}{' '}
                        {applicantInfo?.candidate?.middleName}{' '}
                        {applicantInfo?.candidate?.lastName}
                      </Text>
                      <Spacer space="8px" />
                      <Text bold>Application Number:</Text>
                      <Text>{applicantInfo?.candidate?.applicationNumber}</Text>
                      <Spacer inline direction="horizontal" />
                      <Spacer className="show-on-mini" />
                      <StatusIndicator
                        label={applicantInfo?.candidate?.status}
                        color={
                          stepTypeColor[applicantInfo?.candidate?.status] ||
                          Theme.PrimaryYellow
                        }
                        compound
                      />
                    </Box>
                    <Spacer space="8px" />
                  </div>
                  <div className="flex-div applicant-info-actions">
                    <Button onClick={() => login()} style={{ width: '100%' }}>
                      Login to view more
                    </Button>
                  </div>
                </div>
                <div className="applicant-detail">
                  <div className="applicant-detail-info">
                    <Box>
                      <Text bold>Application: </Text>
                      <Text
                        size="14px"
                        capitalize
                        color={Theme.PrimaryColor}
                        bold
                      >
                        {applicantInfo?.candidate?.applicationTitle}{' '}
                      </Text>
                    </Box>
                    <Box>
                      <Text bold uppercase>
                        Course Code:
                      </Text>{' '}
                      <Text uppercase>
                        {applicantInfo?.candidate?.course?.code}
                      </Text>
                    </Box>
                    <Box>
                      <Text bold uppercase>
                        Course:
                      </Text>{' '}
                      <Text uppercase>
                        {applicantInfo?.candidate?.course?.title}
                      </Text>
                    </Box>
                  </div>
                  <div className="applicant-detail-photo">
                    {formItemData?.passport_picture && (
                      <Box className="applicant-detail-photo-container">
                        <img
                          src={formItemData?.passport_picture}
                          alt="Passport"
                        />
                      </Box>
                    )}
                  </div>
                </div>
              </>

              <div className="application-detail">
                <Box pad="20px" className="view-applicant-box">
                  <Tabs responsive={-1} background="#fff">
                    <div
                      iconRight={<i className="saf-sliders" />}
                      label="Application Information"
                    >
                      <>
                        <Box className="applicant-infox">
                          {formItem
                            .filter((item) => +item.inputs?.length > 0)
                            .map((item, i) => (
                              <Box className="applicant-infox-row" key={i}>
                                <Text
                                  block
                                  bold
                                  capitalize
                                  size="16px"
                                  uppercase
                                  className="applicant-infox-row-header"
                                >
                                  {item?.title}
                                </Text>

                                {item?.inputs?.map((eachRow, rowIndex) => (
                                  <Grid
                                    className="form-grid"
                                    default={getColumnStructure(eachRow)}
                                    gap="0px"
                                    key={`row-${rowIndex}`}
                                  >
                                    {eachRow.map((eachField, i) => (
                                      <Box key={i} className="single-form">
                                        <Text
                                          color={({ theme }) =>
                                            theme.PrimaryInputOutline
                                          }
                                          uppercase
                                          bold
                                          block
                                        >
                                          {eachField?.title}
                                        </Text>

                                        {eachField?.source ===
                                        'nigeria-states-lga' ? (
                                          <Text capitalize size="15px" block>
                                            {formatAddress(
                                              formItemData?.[eachField?.id]
                                            )}
                                          </Text>
                                        ) : (
                                          <Text
                                            capitalize={
                                              !['email', 'wysiwyg'].includes(
                                                eachField?.type?.toLowerCase()
                                              )
                                            }
                                            size="15px"
                                            block
                                          >
                                            {eachField?.type === 'checkbox' ? (
                                              <>
                                                {formItemData?.[eachField.id]
                                                  ? eachField.trueDisplay
                                                  : eachField.falseDisplay}
                                              </>
                                            ) : (
                                              <>
                                                {eachField?.type?.toLowerCase() ===
                                                  'date' &&
                                                formItemData?.[
                                                  eachField?.id
                                                ] ? (
                                                  <p>
                                                    {moment(
                                                      formItemData?.[
                                                        eachField?.id
                                                      ]
                                                    )
                                                      .tz(FALL_BACK_TZ)
                                                      .format('MMMM Do YYYY')}
                                                  </p>
                                                ) : (
                                                  <p
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        formItemData?.[
                                                          eachField?.id
                                                        ] || EMPTY_VALUE,
                                                    }}
                                                  />
                                                )}
                                              </>
                                            )}
                                          </Text>
                                        )}
                                      </Box>
                                    ))}
                                  </Grid>
                                ))}
                              </Box>
                            ))}
                        </Box>
                      </>
                    </div>
                  </Tabs>
                </Box>
              </div>
            </div>
          </SideModalFullScreen>
        </>
      )}
    </Wrapper>
  );
};

export default VerifyCandidateInfo;

const Wrapper = styled.div`
  width: 100%;
`;
